<template>
  <div class="withdraw-container py-2 py-lg-4 col-12 col-lg-7  mx-auto mb-5">
    <h4 class="w-100 text-center text-white my-3 my-lg-5 page-main-title">
      Вывод средств
    </h4>
    <div class="col-12 mx-auto">
      <b-tabs class="pb-3 px-0 text-center home-pills" pills>
        <b-tab class="col-12">
            <template slot="title" class="mx-0">
            <div class=" py-0 col-12 text-center category-item px-0">
                <button class="btn pay-tab py-2 w-100" name="withdraw">
                    Выплата
                </button>
            </div>
            </template>

            <div class="pay-tab-body">
            <div class="withdraw" ref="withdraw">
                <div class="withdraw-inner">
                  <div v-if="withdrawMethods.regular && withdrawMethods.regular.length > 0" class="row mx-0 mt-5">
                  <div class="col-12 col-sm-12 px-0 py-3 py-md-4 page-dark-bg ">
                    <div class="w-100 text-white px-3 mb-2 text-center">
                      <span class="choose-method-txt">Выберите способ выплаты</span>
                    </div>
                    <div class="col-12 px-0">
                      <div class="col-12 px-0 col-lg-9 mx-auto row mx-0 justify-content-around">
                        <div
                                v-for="method in withdrawMethods.regular" :key="method.id"
                                class="paymethod-label pay-method-itm-style row"
                                :class="[method.name === selectedMethod.name ? 'selected' : '']"
                                @click.prevent="changeMethod(method)"
                                v-lazy-container="{ selector: 'img', loading: require('@/../public/images/icons/main-loader.svg') }">
                          <img
                                  :src="method.img"
                                  :data-src="method.img"
                                  :alt="'VipMagnit казино вывод средств - метод  '+method.name"
                                  class="pay-method-image m-auto mw-100">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="selectedMethod.name && userData"
                      class="col-12 col-sm-12 row mx-0 justify-content-between px-0 bg-dark-red mt-4 pb-3 pt-lg-4 pb-lg-5">
                    <div class="col-12">
                      <b-form class="withdraw-form my-4 col-12 row mx-0 justify-content-between justify-content-lg-start px-0">
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4 pl-lg-0">
                          <div class="input-group mb-2">
                            <div class="col-12 px-0">
                              <input
                                      id="withdraw-amount" v-model="payload.amount"
                                      class="form-control main-input"
                                      type="text"
                                      :min="selectedMethod.min_amount"
                                      :max="selectedMethod.max_amount"
                                      v-on:keyup="keyUp"
                                      placeholder="Сумма в рублях" required>
                            </div>
                            <span  class="hint-amount" v-if="withdrawinfo" style="margin-top: 10px">{{ withdrawinfotext }}</span>
                          </div>
                        </div>
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4">
                          <div class="input-group">
                            <div class="col-12 px-0">
                              <input
                                      v-model="payload.recipient"
                                      v-mask="getSelectedMethodMask"
                                      class="form-control main-input"
                                      type="text"
                                      :placeholder="selectedMethod.name === '' ? 'Выбеите способ выплаты': 'Введите '+ selectedMethod.requisites_title">
                              <p class="add-info">
                               {{ selectedMethod.add_info }}
                            </p>
                            </div>
                          </div>
                        </div>
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4" v-if="selectedMethod.additional_info.length">
                          <div class="input-group">
                            <div class="form-group mb-2">
                                <div class="col-12 px-0">
                                  <select v-model="payload.bank" id="selectBank" class="main-input main-select form-control">
                                        <option :value="''" selected>Выбери банк</option>
                                        <option v-for="(method, index) in selectedMethod.additional_info"
                                        :key="index"
                                        :value="method.code">
                                        {{ method.name }}
                                        </option>
                                    </select>   
                                </div>
                              </div>
                          </div>
                        </div>

                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4 pl-lg-0" v-if="selectedMethod.requisite_holder_name == 1">
                          <div class="input-group mb-2">
                            <div class="col-12 px-0">
                              <input
                                  v-model="payload.requisite_holder"
                                  class="form-control main-input"
                                  type="text"
                                  placeholder="Введите ФИО владельца реквизита" required>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 tip" v-if="tipData && tipData.use && tipData.use === true ">
                          <div class="tip-block">
                              <div class="text-block">
                                  <p>Хочу оставить на чай</p>
                              </div>
                              <div class="tip-type-block">
                                  <div class="fin" v-for="(data, index) in tipTypesData" :key="index">
                                      <label for="finButton">
                                        <img :src="data.src" class="fin-icon tip-type"
                                        :class="{ 'active-type': index === activeType }"
                                        @click="tipTypeAction(data.value,index)">
                                      </label>
                                      <div class="text-center">
                                          <span>{{data.label}}</span>
                                      </div>
                                      <div class="check-block" >
                                          <svg class="checkmark" width="40" height="40" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'active-check': index === activeType }">
                                              <path class="checkmark__check" d="M24 51.6739C25.8629 51.6739 35.5417 62.1638 40.8583 68.0867C42.7759 70.223 46.0818 70.3683 48.1455 68.3727C57.6301 59.2012 81.8373 36 84 36" stroke="#098a1b" stroke-width="10" stroke-linecap="round" />
                                          </svg>
                                      </div>
                                  </div>
                              </div>
                              <div class="tip-amount-block">
                                  <div class="smaylik-amount-block">
                                      <div class="amout-smayl" v-for="(data, index) in tipAmountData" :key="index">
                                          <label for="amountBtn10">
                                            <img :src="data.src" class="amount-icon"
                                            @click="tipAmountAction(tipData.amounts[index],index)"
                                            :class="{ 'active-amount': index === activeAmount }"
                                            >
                                          </label>
                                      </div>
                                  </div>
                                  <div class="samyl-text-block">
                                      <span>Выберите сумму для чаевых от {{ tipData.amounts[0] }}  руб․</span>
                                  </div>
                                  <div>
                                      <input  v-model="tipAmount"
                                              v-on:keyup="tipAmountkeyUp"
                                              placeholder="Сумма на чай"
                                              class="form-control input-md rect tip-amount-val">
                                  </div>
                              </div>
                          </div>
                      </div>
                        <b-row class="mt-2 mx-0 col-12">
                          <div class="col-12 col-lg-3 mx-auto px-0">
                            <div class="green-btn-bg">
                              <button
                                      name="openModal"
                                      class="btn main-btn w-100 text-white"
                                      :disabled="isSubmitting"
                                      @click.stop.prevent="openModal()"
                                      >
                                Подтвердить
                              </button>
                            </div>
                          </div>
                        </b-row>

                        <div class="row mx-0 col-12 px-0">
                          <Alert :message="formResponse"></Alert>
                        </div>
                      </b-form>
                    </div>
                    <div class="col-12">
                      <span class="gray-color deposit-hint">Минимальная сумма выплаты {{ selectedMethod.min_amount }} руб.</span><br>
                      <span class="gray-color deposit-hint">Максимальная сумма выплаты {{ selectedMethod.max_amount }} руб. за один перевод.</span><br>
                      <span class="gray-color deposit-hint" v-if="selectedMethod.time">
                        до {{ selectTime(selectedMethod.time) }}
                      </span><br>
                      <span class="gray-color deposit-hint">{{ selectedMethod.add_info }}</span>
                      <span></span>
                    </div>
                  </div>
                </div>
                <div v-else class="row justify-content-center w-100 color-red mx-0 h-100 py-4">
                  <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
                </div>
                </div>
            </div>
            </div>
        </b-tab>


        <b-tab class="col-12" v-if="withdrawMethods.vip && withdrawMethods.vip.length > 0">
          <template slot="title" class="mx-0">
            <div class=" py-0 col-12 text-center category-item px-0">
              <button class="btn pay-tab py-2 w-100" name="vip_withdraw">
                VIP Выплата
              </button>
            </div>
          </template>

          <div class="pay-tab-body">
            <div class="vipwithdraw" ref="vipwithdraw">
              <div class="withdraw-inner">
                <div v-if="withdrawMethods.vip && withdrawMethods.vip.length" class="row mx-0 mt-5">
                  <div class="col-12 col-sm-12 px-0 py-3 py-md-4 page-dark-bg ">
                    <div class="w-100 text-white px-3 mb-2 text-center">
                      <span class="choose-method-txt">Выберите способ выплаты</span>
                    </div>
                    <div class="w-100 text-white px-3 mb-2 text-center">
                      <span class="choose-method-txt" v-html="vipWithdrawalText"></span>
                    </div>
                    <div class="col-12 px-0">
                      <div class="col-12 px-0 col-lg-9 mx-auto row mx-0 justify-content-around">
                        <div
                            v-for="method in withdrawMethods.vip" :key="method.id"
                            class="paymethod-label pay-method-itm-style row"
                            :class="[method.name === selectedMethod.name ? 'selected' : '']"
                            @click.prevent="changeMethod(method)"
                            v-lazy-container="{ selector: 'img', loading: require('@/../public/images/icons/main-loader.svg') }">
                          <img
                              :src="method.img"
                              :data-src="method.img"
                              :alt="'VipMagnit казино вывод средств - метод  '+method.name"
                              class="pay-method-image m-auto mw-100">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="selectedMethod.name && userData"
                       class="col-12 col-sm-12 row mx-0 justify-content-between px-0 bg-dark-red mt-4 pb-3 pt-lg-4 pb-lg-5">
                    <div class="col-12">
                      <b-form class="withdraw-form my-4 col-12 row mx-0 justify-content-between justify-content-lg-start px-0">
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4 pl-lg-0">
                          <div class="input-group mb-2">
                            <div class="col-12 px-0">
                              <input
                                  id="withdraw-amount" v-model="payload.amount"
                                  class="form-control main-input"
                                  type="text"
                                  :min="selectedMethod.min_amount"
                                  :max="selectedMethod.max_amount"
                                  v-on:keyup="keyUp"
                                  placeholder="Сумма в рублях" required>
                            </div>
                            <span  class="hint-amount" v-if="withdrawinfo" style="margin-top: 10px">{{ withdrawinfotext }}</span>
                          </div>
                        </div>
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4">
                          <div class="input-group">
                            <div class="col-12 px-0">
                              <input
                                  v-model="payload.recipient"
                                  v-mask="getSelectedMethodMask"
                                  class="form-control main-input"
                                  type="text"
                                  :placeholder="selectedMethod.name === '' ? 'Выбеите способ выплаты': 'Введите '+ selectedMethod.requisites_title">
                            </div>
                          </div>
                        </div>
                        <div class="input-group mb-2 mb-lg-4 col-12 col-sm-4 col-lg-4" v-if="selectedMethod.additional_info.length">
                          <div class="input-group">
                            <div class="form-group mb-2">
                              <div class="col-12 px-0">
                                <select v-model="payload.bank" id="selectBank" class="main-input main-select form-control">
                                  <option :value="''" selected>Выбери банк</option>
                                  <option v-for="(method, index) in selectedMethod.additional_info"
                                          :key="index"
                                          :value="method.code">
                                    {{ method.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <b-row class="mt-2 mx-0 col-12">
                          <div class="col-12 col-lg-3 mx-auto px-0">
                            <div class="green-btn-bg">
                              <button
                                  name="openModal"
                                  class="btn main-btn w-100 text-white"
                                  @click.stop.prevent="openModal()"
                              >
                                Подтвердить
                              </button>
                            </div>
                          </div>
                        </b-row>

                        <div class="row mx-0 col-12 px-0">
                          <Alert :message="formResponse"></Alert>
                        </div>
                      </b-form>
                    </div>
                    <div class="col-12">
                      <span class="gray-color deposit-hint">Минимальная сумма выплаты {{ selectedMethod.min_amount }} руб.</span><br>
                      <span class="gray-color deposit-hint">Максимальная сумма выплаты {{ selectedMethod.max_amount }} руб. за один перевод.</span><br>
                      <span class="gray-color deposit-hint" v-if="selectedMethod.time">
                        до {{ selectTime(selectedMethod.time) }}
                      </span><br>
                      <!-- <span class="gray-color deposit-hint">Максимальный вывод в течение суток 50.000 рублей, остаточный выигрыш можете вывести на следующий день.</span><br> -->
                      <span class="gray-color deposit-hint">{{ selectedMethod.add_info }}</span>
                      <span></span>
                    </div>
                  </div>
                </div>
                <div v-else class="row justify-content-center w-100 color-red mx-0 h-100 py-4">
                  <i class="fa fa-spinner fa-spin fa-fw my-auto"></i>
                </div>
              </div>
            </div>
          </div>
        </b-tab>



        <b-tab class="col-12" v-if="userData">
            <template slot="title" class="mx-0">
            <div class="tab-title py-0 col-12 text-center category-item px-0">
                <button class="btn pay-tab py-2 w-100" name="history">
                    История
                </button>
            </div>
            </template>

            <div class="pay-tab-body">
            <div class="history" ref="history">
                <div class="history-inner">
                   <div>
                    <b-tabs class="pb-3 px-0 text-center" pills>
                        <b-tab class="col-12">
                            <template slot="title" class="mx-0">
                            <div class=" py-0 col-12 text-center category-item px-0">
                                <button class="btn  pay-tab py-2 w-100" name="history_withdraw">
                                    Депозит
                                </button>
                            </div>
                            </template>

                            <div class="pay-tab-body">
                            <div class="history" ref="history">
                                <div class="history-inner">
                                    <History :histories="depositHistory ? depositHistory : null " :mode="'deposit'"/>
                                </div>
                            </div>
                            </div>
                        </b-tab>
                        <b-tab class="col-12">
                            <template slot="title" class="mx-0">
                            <div class=" py-0 col-12 text-center category-item px-0">
                                <button class="btn  pay-tab py-2 w-100" name="history_withdraw">
                                    Выплата
                                </button>
                            </div>
                            </template>

                            <div class="pay-tab-body">
                            <div class="history" ref="history">
                                <div class="history-inner">
                                    <History :histories="withdrawHistory ? withdrawHistory : null" :mode="'withdraw'"/>
                                </div>
                            </div>
                            </div>
                        </b-tab>
                    </b-tabs> 
                   </div>
                </div>
            </div>
            </div>
        </b-tab>
      </b-tabs> 
    </div>
    <b-modal
            v-if="selectedMethod"
            id="confirmWithdrawModal" v-model="confirmWithdrawModal"
            size="md"
            modal-class="main-modal"
            :hide-header="true"
            footer-border-variant="gray">
      <div class="col-12 px-0 text-center">
        <span class="text-white" v-html="hint"></span>

        <div class="row mx-0 my-3">
          <Alert :message="popupMessages"></Alert>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel}" class="border-0">
        <b-button name="cancel"
                  size="sm" class="btn dark-btn"
                  @click="cancel()">
          Отмена
        </b-button>
        <b-button name="makeWithdraw"
                  size="sm" class="btn main-btn text-white"
                  @click.prevent="makeWithdraw()">
          Вывести
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
const moneyIcon = ''
import Alert from '@/components/Alert'
import History from './History.vue'

export default {
  name: 'Withdraw',
  data () {
    return {
      currentPath: null,
      moneyIcon,
      tipType:'',
      tipAmount:'',
      tipTypesData:[
         {src:require('@/../public/images/icons/tips/fin1.png'), value:1, label: "Фин.Отдел"},
         {src:require('@/../public/images/icons/tips/meneg1.png'), value:2, label: "Менеджер"},
      ],
      tipAmountData:[
         {src:require('@/../public/images/icons/tips/10.png')},
         {src:require('@/../public/images/icons/tips/50.png')},
         {src:require('@/../public/images/icons/tips/100.png')},
         {src:require('@/../public/images/icons/tips/no-tip.png')},
      ],
      activeAmount:'',
      activeType:'',
      payload: {
        recipient: '',
        amount: '',
        bank: '',
        requisite_holder: '',
      },
      selectedMethod: {
        name: '',
        mask: '',
        min_amount: 0,
        max_amount: 0,
        type: '',
        time:'',
        add_info: '',
        additional_info:'',
        requisite_holder_name:'',
      },
      isSubmitting: true,
      modalConfirmed: false,
      confirmWithdrawModal: false,
      formResponse: {},
      popupMessages: {},
      hint: '',
      withdrawinfo: false,
      withdrawinfotext: ''
    }
  },
  components: {
    Alert,
    History
  },
  computed: {
    getSelectedMethodMask () {
      if(this.selectedMethod.mask != ''){
          return typeof this.selectedMethod.mask === 'string' ? this.selectedMethod.mask : this.selectedMethod.mask.join(',').split(',');
      }
      return null;
    },
    withdrawMethods () {
      return this.$store.getters.getWithdrawMethods
    },
    withdrawHistory () {
      return this.$store.getters.getLastWithdrawHistory
    },
    depositHistory () {
      return this.$store.getters.getDepositHistory
    },
    userData () {
      return this.$store.getters.userData
    },
    isMobile() {
      return this.$_config.isMobile()
    },
    tipData() {
      return this.$store.getters.getTipData
    },
    vipWithdrawalText() {
      return this.$store.getters.getVipWithdrawalText
    },
    vipWithdrawalPercent() {
      return this.$store.getters.getVipWithdrawalPercent
    }
  },
  methods: {
    changeMethod (method) {
      this.withdrawinfo = false
      if (!this.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для вывода средств нужно авторизоваться')
      }
      this.isSubmitting = true
      this.tipType = '';
      this.tipAmount = '';
      this.payload.bank = '';
      this.payload.requisite_holder = '';
      this.payload.recipient = '';
      this.activeAmount = '',
      this.activeType = '',
      this.selectedMethod = method
      this.formResponse = {}

      setTimeout(() => {
        const amountInput = document.getElementById('withdraw-amount')
        if (amountInput) {
          amountInput.focus()
        }
      }, 100)
      const elem = document.querySelector('#withdraw-area')
      if(elem){
        let position = elem.getBoundingClientRect().top + document.documentElement.scrollTop
      position = parseInt(position)
      window.scrollTo({
        top: position,
      })
      }
    },
    tipAmountkeyUp(){
      this.isSubmitting = false
    },
    selectTime(time){
        if(time > 59){
        let hours = Math.floor(time / 60);
        let minutes = time % 60;
        let  formatTime = hours + " ч. ";
        if (minutes !== 0) {
          formatTime += minutes + " мин.";
        }
        return formatTime ;
        }else{
          return time + " мин.";
        }
    },
    makeWithdraw () {
      if (!this.userData) {
        return
      }
      this.formResponse = { status: 'loading' }
      this.popupMessages = { status: 'loading' }
      this.isSubmitting = true

      const formData = new FormData();
      formData.append('withdraw_amount', this.payload.amount);
      formData.append('withdraw_requisites', this.payload.recipient);
      formData.append('method', this.selectedMethod.type);
      formData.append('bank', this.payload.bank);
      formData.append('requisite_holder', this.payload.requisite_holder);
      formData.append('tipType', this.tipType);
      formData.append('tipAmount', this.tipAmount);

      this.axios.post(
        this.$_config.baseUrl + '/Api/newWithdraw',formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(({ data }) => {
        if (data.status === 'ok') {
          this.popupMessages = data
          this.formResponse = {}
          this.activeAmount = '',
          this.activeType = '',
          setTimeout(() => {
            this.payload.amount = null
            this.payload.recipient = null
            this.$root.$emit('bv::hide::modal', 'confirmWithdrawModal')
            if(data.data.enable_waiting_withdraw_modal == 1 ){
              this.$root.$emit('bv::show::modal', 'AfterWithdrawModal')
              this.countDownDate()
            }
          }, 2000)
        } else {
          this.confirmWithdrawModal = false
          this.formResponse = data
        }
        this.isSubmitting = false
      }).catch(err => {
        console.log(err)
      })
      return true
    },
    openModal () {
      this.formResponse = {}
      this.popupMessages = {}
      if (!this.$store.getters.userData) {
        this.$root.$emit('bv::show::modal', 'loginModal')
        return this.$root.$emit('reasonToLogin', 'Для вывода средств нужно авторизоваться')
      }

      if (!this.selectedMethod.name) {
        this.formResponse = { status: 'error', msg: 'Пожалуйста выберите платежную систему' }
        return false
      }

      if (!this.payload.amount || this.payload.amount != parseFloat(this.payload.amount)) {
        this.formResponse = { status: 'error', msg: 'Пожалуйста, укажите правильую сумму' }
        return false
      }

      if (this.payload.amount < this.selectedMethod.min_amount) {
        this.formResponse = { status: 'error', msg: 'Минимальная сумма для выбранного метода  ' + this.selectedMethod.min_amount }
        return false
      }

      if (this.payload.amount > this.selectedMethod.max_amount) {
        this.formResponse = { status: 'error', msg: 'Максимальная сумма для снятия ' + this.selectedMethod.max_amount }
        return false
      }

      if (!this.payload.recipient) {
        this.formResponse = { status: 'error', msg: 'Заполните реквизты.' }
        return false
      }
      this.confirmWithdrawModal = true
      this.hint = 'Подтвердите вывод на ' + this.payload.recipient + '. На сумму ' + this.payload.amount + 'Руб.'
      if(this.selectedMethod.is_vip == 1){
        if(this.vipWithdrawalPercent) {
          this.hint = "При использовании VIP-вывода взимается комиссия " + this.vipWithdrawalPercent + "%.<br/>";
        }

        this.hint += "Ваш вывод " + this.payload.amount + " руб. — будет отправлено " + (this.payload.amount * (100 - this.vipWithdrawalPercent)) / 100 + " руб на " +
            this.payload.recipient + ". <br/><br/> Заявки обрабатываются в течение 30–60 минут и отправляются одной транзакцией."
      }
    },
    keyUp(evt){
      this.withdrawinfo = false
      if(this.selectedMethod.type === "visacardpercent" && evt.target.value >= this.selectedMethod.min_amount){
        this.withdrawinfo = true
        this.withdrawinfotext = "Поступят "+(evt.target.value-50)+" руб, 50 руб комиссия"
      }
    },
    tipTypeAction(type,index) {
      this.tipType = type
      this.activeType = index  
    },
   
    tipAmountAction(amount,index){
      this.isSubmitting = false
      this.activeAmount = index
      if(typeof amount === "undefined"){
        this.tipAmount = ''
      }else{
        this.tipAmount = amount
      }
    },
    countDownDate() {
      var countDownDate = new Date().getTime() + 60 * 60 * 1000;
      var x = setInterval(function () {
        var now = new Date().getTime();
        var distance = countDownDate - now;
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if(minutes <= 9){
          minutes = "0"+minutes;
        }
        if(seconds <= 9){
          seconds = "0"+seconds;
        }
        document.getElementById("waiting-data-area").innerHTML = minutes + ":" + seconds;
        if (distance <= 0) {
          clearInterval(x);
          window.location.reload()
        }
      }, 1000);
    }
  },
  mounted () {
    if (!this.userData) {
      return this.$router.push({ name: 'login' })
    }
    this.$store.dispatch('getWithdrawHistory')
    this.$store.dispatch('getDepositHistory')
    setTimeout(() => {
      const withdrawMethod = document.querySelector('.withdraw-method')
      if (withdrawMethod) {
        withdrawMethod.click()
      }
    }, 500)
  }
}
</script>

<style scoped>
  .paymethod-label {
    margin: 10px;
    background-color: #fff;
    height: 80px;
    width: 26%;
    padding: 10px;
    text-align: center;
  }

  .pay-method-itm-style {
    float: left;
    cursor: pointer;
    border-radius: 3px;
    border: solid 1px transparent;
  }

  .main-select option{
    background-color: black;
    color: rgb(255, 254, 254)!important;;
  }
  .tip{
    margin-top: 50px;
    display: flex;
    justify-content: center;
}
.tip-block{
    width: 300px;
}
.fin-icon,
.mange-icon{
    cursor: pointer;
    transition: fill 0.3s;
    border-radius: 50%;
    object-fit: contain;
}
.samyl-text-block{
    text-align: center;
}
.text-block{
    margin-top: 20px;
    font-size: 20px;
}
.mange span{
    margin-right: 20px;
}
.tip-type-block{
    height: 130px;
    display: flex;
    justify-content: space-around;
}
.tip-type{
  width: 70px;
  height: 70px;
  transition: width 0.5s, height 0.5s;
}
.active-type{
  width: 80px;
  height: 80px;
}
.smaylik-amount-block{
    height: 70px;
    display: flex;
    justify-content: space-between;
}
.text-block p{
    text-align: center;
}
.amount-icon{
    width: 40px;
    height: 40px;
    cursor: pointer;
    border-radius: 50%;
    transition: width 0.5s, height 0.5s;
}
.active-amount{
    width: 60px;
    height: 60px;
}
.tip-amount-block{
    margin-top: 30px;
}

.tip-amount-val{
    margin-top: 30px;
    margin-bottom: 30px;
}
.checkmark{
  display: none;
}
.active-check{
  display: block;
}
.check-block{
    display: flex;
    justify-content: center;
}
.checkmark__check {
    stroke-dasharray: 412;
    stroke-dashoffset: 412;
    animation: anim 1s ease forwards 0.3s;
}
.add-info{
  color: #ffffff;
  font-weight: bold;
  margin-top: 20px;
 }
@keyframes anim {
    to {
        stroke-dashoffset: 0;
    }
}

  .pay-tab{
      color: #fff!important;
  }

  .nav-pills .nav-link.active .pay-tab {
      border-bottom: 2px solid #e7021e;
  }
  
  .pay-tab:active,
  .pay-tab:focus {
      outline: none; 
      box-shadow: none!important;
  }

  @media (max-width: 992px) {
      #paymentModal{
          padding-left: 0 !important;
      }
  }
  @media (max-width:402px) {
      .pay-tab{
        font-size: 13px;
      }
  }
  @media (max-width:338px) {
      .pay-tab{
        font-size: 11px;
      }
      .nav-pills{
      height: 43px;
  }
}
</style>
  
<style>
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
        color: aliceblue;
        background-color: unset!important;
    }

    .nav-pills .nav-link {
        padding: 0.5rem;
    }
    .nav-pills{
        height: 47px;
        border-bottom: 1px solid rgb(143, 141, 141);
    }
    @media (max-width:338px) {
        .nav-pills{
        height: 43px;
    }
    }
</style>